"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowSize = void 0;
const react_1 = require("react");
function useWindowSize() {
    const [size, setSize] = (0, react_1.useState)({
        height: window.innerHeight,
        width: window.innerWidth,
    });
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            setSize({ height: window.innerHeight, width: window.innerWidth });
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return size;
}
exports.useWindowSize = useWindowSize;
//# sourceMappingURL=useWindowSize.js.map